export default (function splitIntoParagraphs(htmlString) {
  const regex = /<p\b[^>]*>(.*?)<\/p>/g;
  const paragraphs = htmlString.match(regex);
  return paragraphs;
});